import { Modal } from "react-bootstrap"

import '../../style.scss'
import View from "../viewDescription";
import React, { useEffect } from "react";
import ViewConfirmIgnore from "../ignore";
import InitialMessage from "../initialMessageView";
import RequsetPendingReason from "../requsetPendingReason";
import { CloseIcon } from "../../../../assets/images/svg/closeIcon";
import { enToPersianChar } from "../../../../functions/extensions/enToPersianChar";
import BlockUser from "../blockUser";
import UnBlockUser from "../unBlockUser";

type Props = {
    from: string,
    header: string,
    setStates: Function,
    states: any,
    changeStatus: Function | undefined,
    loading: boolean | undefined,

}



const ModalContent = ({ from, header, setStates, states, changeStatus, loading }: Props) => {

    const handleClose = () => {
        setStates({ show: false })
    }

    return (
        <Modal show={states?.show} onHide={() => setStates({ show: false })} animation={true} dir="rtl" className="modal-status-activity">
            <Modal.Header>
                <Modal.Title className="d-flex justify-content-between w-100" style={{ fontSize: '16px' }}>
                    {header}
                    <span onClick={handleClose}><CloseIcon /></span>
                </Modal.Title>
            </Modal.Header>

            <div className='sensitive-activity-modal-content-view mt-2'>

                {from !== "InvestigationPending" && <>
                    <div className="d-flex justify-content-start align-items-center">
                        <label>شماره خط: </label>
                        <span>{enToPersianChar(states?.item?.customerLineNumber.replace("+98","0"))}</span>
                    </div>
                    <div className="d-flex justify-content-start align-items-center">
                        <label>نام مشترک: </label>
                        <span>{states?.item?.customerFullName}</span>
                    </div>
                </>}

                {from === "InitialMessageView" && <InitialMessage states={states} />}
                {from === 'RequsetPendingReason' && changeStatus && loading !== undefined && <RequsetPendingReason setStates={setStates} item={states?.item} changeStatus={changeStatus} loading={loading} />}
                {from === 'InvestigationPending' && <View item={states?.item} />}
                {from === 'BlockUser' && changeStatus && loading !== undefined && <BlockUser changeStatus={changeStatus} setStates={setStates} item={states?.item} loading={loading} />}
                {from === 'UnBlockUser' && changeStatus && loading !== undefined && <UnBlockUser changeStatus={changeStatus} setStates={setStates} item={states?.item} loading={loading} />}

                {from === 'Ignore' && changeStatus && loading !== undefined && <ViewConfirmIgnore changeStatus={changeStatus} setStates={setStates} item={states?.item} loading={loading} />}


            </div>

        </Modal >
    )
}
export default ModalContent